/**
 * Region id для SWR-ключей: синхронно из storage, без ожидания React-state.
 * Иначе prefetch (без region) и страница (с region) пишут в разные ключи — при клике снова холодный fetch.
 */
export function getStableClientRegionId(): number | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  try {
    const fromSession = sessionStorage.getItem('current_region_id');
    if (fromSession) {
      const n = Number(fromSession);
      if (Number.isFinite(n) && n > 0) return n;
    }

    const fromLocal = localStorage.getItem('selected_region_id');
    if (fromLocal) {
      const n = Number(fromLocal);
      if (Number.isFinite(n) && n > 0) return n;
    }
  } catch {
    // ignore
  }

  return undefined;
}
